import { useTranslation } from 'react-i18next';
import { FormSection } from '@zolteam/zol-admin-ui';
import { FormElements } from '@zolteam/zol-react-form';
import AutocompleteAirports from '../../../organisms/autocompleteAirports/AutocompleteAirports';

/**
 * @typedef {object} BookingDepartureSectionProps
 * @property {import('@zolteam/zol-react-form/types').ConfigObject} formConfig
 * @property {{formName: string}} formInfo - The form information object
 * @property {{value: string, label: string} | null} departureAirport - Selected departure airport
 * @property {string} departureAirportError - Departure airport field error message
 * @property {(
 * airport: {value: string, label: string}, formInfo: object) => void} handleSetDepartureAirport
 * @property {(formInfo: object) => void} handleDepartureBlur - Airport field blur handler
 */

/**
 * Departure section of the booking form
 * @param {BookingDepartureSectionProps} props
 * @returns {JSX.Element}
 */
function BookingDepartureSection({
  formConfig,
  formInfo,
  departureAirport,
  departureAirportError,
  handleSetDepartureAirport,
  handleDepartureBlur,
}) {
  const { t } = useTranslation();

  return (
    <FormSection label={t('bookingForm.section.departure')}>
      <AutocompleteAirports
        label={t('bookingForm.fields.departureAirportCode')}
        value={departureAirport}
        setAirport={(
          /** @type {{label: string, value: string}} */newAirport,
        ) => handleSetDepartureAirport(newAirport, formInfo)}
        errorMessage={departureAirportError}
        name="departureAirport"
        onBlur={() => handleDepartureBlur(formInfo)}
      />
      <div className="margin-top-s">
        <FormElements
          translations={null}
          formConfig={formConfig}
          formTitle={formInfo.formName}
        />
      </div>
    </FormSection>
  );
}

export default BookingDepartureSection;
